import { handleActions } from 'redux-actions';
import { actions } from '../actions/visibility';
// Destructure the visibility actions.
export const { visibilityHidden, visibilityShown } = actions;
// Init state for the websocket.
const initialState = {
    isHidden: false,
};
// Reducer
export const visibility = handleActions({
    [visibilityHidden.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { isHidden: true });
    },
    [visibilityShown.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { isHidden: false });
    },
}, initialState);
